import { assign, compose, get, map, reduce } from 'lodash/fp';

const mergeObjects = reduce(assign, {});
const getFromModules = compose(map, get);

export const getReducers = compose(mergeObjects, getFromModules('reducers'));
export const getSagas = compose(mergeObjects, getFromModules('sagas'));
